import comp from "./CountdownScreen";
export default comp;
